import React, { Component } from "react";
import { connect } from "react-redux";
import soldier from "../../static/roman_soldier.png";
//import sign from "../../static/sign.png";
import logo from "../../static/logo-title.png";
import "./landing.scss";
import { ReactComponent as Right } from "../../static/arrowRight.svg";
import { NavLink } from "react-router-dom";

const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedLandingPage extends Component {
  render() {
    return (
      <div>
        <div
          style={{
            position: "fixed",
            bottom: "0",
            left: "0",
            paddingTop: "2.65%",
            paddingLeft: "5%",
            backgroundImage: 'url("' + soldier + '")',
            height: "686px",
            width: "450px",
            backgroundSize: "cover",
          }}
        >
          {/*  <img alt="soldier" src={soldier} style={{}} /> */}
        </div>
        <div
          style={{
            position: "fixed",
            top: "0",
            right: "0",
            paddingTop: "2.65%",
            paddingRight: "5%",
          }}
        >
          <img
            src={logo}
            alt="sign"
            style={{ width: "261px", heigh: "124px" }}
          />
        </div>
        <div>
          <div
            style={{ width: "445px", margin: "0 auto", paddingTop: "100px" }}
          >
            <h1
              style={{ fontSize: "50px", textAlign: "center" }}
              className="bold-font"
            >
              Servus humillimus domini!
            </h1>
            <div style={{ fontSize: "30px", textAlign: "justify" }}>
              Most regisztrálhatsz, hogy az elért eredményeid, a megszerzett
              ezüstérméid révén felkerülhess a dicsőségfalunkra! Kövesd a
              megjelenő utasításokat és készülj a kalandra!
            </div>
          </div>
        </div>

        <div style={{ position: "fixed", bottom: "5%", right: "5%" }}>
          <NavLink to="/register">
            <button
              className="bold-font"
              style={{
                fontSize: "24px",
                backgroundColor: "unset",
                letterSpacing: 0,
                lineHeight: "40px",
                fontWeight: "bold",
                padding: "0.5em 2em 0.5em 0.5em",
                border: "#000000 solid 3.5px",
                textTransform: "uppercase",
                color: "#000000",
                cursor: "pointer",
              }}
            >
              Kezdhetjük!{" "}
              <Right
                style={{
                  margin: 0,
                  position: "absolute",
                  top: "50%",
                  msTransform: "translateY(-50%)",
                  transform: "translateY(-50%)",
                }}
              />
            </button>
          </NavLink>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const LandingPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedLandingPage);
export default LandingPage;
